import createReducer from './createReducer';
import {
  FETCH_FORECAST,
  FETCH_FORECAST_SUCCESS,
  FETCH_FORECAST_FAILURE,
  FORECAST_PRINT_VERSION,
} from '../actions/forecast';

const initialState = {
  loading: false,
  printVersion: false,
  forecast: {},
  interval: 180,
  hasFetched: 0,
};

const handlers = {};

handlers[FETCH_FORECAST] = state => ({
  ...state,
  loading: true,
  hasFetched: state.hasFetched + 1,
});

handlers[FETCH_FORECAST_SUCCESS] = (state, { forecast, interval }) => ({
  ...state,
  loading: false,
  forecast,
  interval,
});

handlers[FETCH_FORECAST_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[FORECAST_PRINT_VERSION] = (state, { printVersion }) => ({
  ...state,
  printVersion,
});


export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/forecast.js